import { useContext } from 'react';

import { ComparisonOfUnitsContext } from '../context';
import { ComparisonOfUnitsContextProps } from '../context/types';

export function useComparisonOfUnits(): ComparisonOfUnitsContextProps {
    return useContext(ComparisonOfUnitsContext);
}
